module.exports = __webpack_public_path__ + "img/room3.9e1a8cfd.png";